import { __assign, __rest } from "tslib";
import React from 'react';
import { cnHeaderLogoInline, cnHeaderImage } from '../Header.const';
import { Link } from '../../Link/Link';
import './Inline-Logo.css';
/**
 * Компонент для отрисовки произвольного логотипа.
 * @param {InlineLogoProps} props
 *
 */
export var InlineLogo = function (_a) {
    var src = _a.src, width = _a.width, height = _a.height, rest = __rest(_a, ["src", "width", "height"]);
    return (React.createElement(Link, __assign({}, rest, { className: cnHeaderLogoInline, tabIndex: -1 }),
        React.createElement("img", { className: cnHeaderImage, src: src, width: width, height: height })));
};
